<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <el-form ref="form" :model="form" :label-width="labelWidth">
      <el-form-item class="item" label="运单列表">
        <el-button size="small" type="primary" @click="showDialog">选择运单</el-button>
        <div class="orderlist" style="margin-top: 15px;">
          <div class="item" v-for="(c, i) in checkedLists" :key="'item' + i">
            <div class="row0">{{ c.order_num }}</div>
            <div class="row1" v-for="(p, i) in modalListProps" :key="'item' + i">
              <div class="col0">{{ p.label }}：</div>
              <div class="col1">{{ c[p.keyName] }}</div>
            </div>
            <div class="rowlast">
              <input type="number" placeholder="请填写补差金额" v-model="c.money" @change="onMoneyChange">
              <div class="unit">元</div>
            </div>
          </div>
        </div>
      </el-form-item>
      <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
        :inputValue="form[c.keyName]" @onChange="onChange" />
    </el-form>

    <div class="btns">
      <SubmitBtn :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>

    <Dialog class="dialog" ref="dialog" :title="title" @closed="onClose">
      <template #default>
        <el-form class="searchForm" :model="modalSearchForm">
          <!-- 普通控件 -->
          <FormItem v-for="(c, i) in modalSearchFormCtrl" :key="'msformItem' + i" :viewMode="false" :config="c"
            :options="c.options" :inputValue="modalSearchForm[c.keyName]" @onChange="onSearchFormChange" />
          <!-- 复合控件 -->
          <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onSearchFormChange" />
          <!-- 搜索按钮 -->
          <el-form-item>
            <el-button type="primary" @click="onModalSearch">搜索</el-button>
          </el-form-item>
          <!-- 重置按钮 -->
          <el-form-item>
            <el-button plain @click="onModalSearchReset">重置</el-button>
          </el-form-item>
        </el-form>

        <!-- <el-form class="modalForm" :model="mform">
          <FormItem v-for="(c, i) in mformCtrl" :key="'mformItem' + i" :viewMode="false" :config="c"
            :options="c.options" :inputValue="mform[c.keyName]" @onChange="onModalFormChange" />
        </el-form> -->

        <el-scrollbar class="modal-scroll" style="height: 460px;">
          <el-checkbox-group class="orderlist" v-model="checkedIds" @change="onCheckChange">
            <el-checkbox class="item" v-for="(c, i) in modalList" :key="'itemm' + i" :label="c.id">
              <div class="row0">{{ c.order_num }}</div>
              <div class="row1" v-for="(p, i) in modalListProps" :key="'item' + i">
                <div class="col0">{{ p.label }}：</div>
                <div class="col1">{{ c[p.keyName] }}</div>
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </el-scrollbar>

        <div class="btns">
          <el-button type="primary" @click="onModalSubmit">确 认</el-button>
          <el-button @click="onModalCancel">取 消</el-button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  name: "FixdDtail",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'compen',
      breadcrumb: [
        { name: "运单管理", path: `/order/makeup` },
        { name: "运单补差", path: `/order/makeup` },
        { name: "运单补差添加" },
      ],
      formCtrl: [
        // {
        //   label: "运费增加",
        //   keyName: "iscustom",
        //   type: "radio",
        //   options: [
        //     { label: '是', value: 1 },
        //     { label: '否', value: 2 },
        //   ],
        // },
        // {
        //   label: "利润增加",
        //   keyName: "iscar",
        //   type: "radio",
        //   options: [
        //     { label: '是', value: 1 },
        //     { label: '否', value: 2 },
        //   ],
        // },
        {
          label: "备注",
          keyName: "content",
          err: "请填写备注信息",
          type: "textarea",
        },
      ],
      form: {
        iscustom: 1,
        iscar: 1,
      },
      title: '请选择运单',
      modalSearchForm: {},
      modalSearchFormCtrl: [
        {
          keyName: "predict_loading_date",
          label: "装货日期：",
          err: "请选择日期",
          type: "date",
        },
      ],
      curSearchKey: 'shname',
      curSearchValue: undefined,
      searchKeyOptions: [
        { label: '车牌号', value: 'license', },
        { label: '运单编号', value: 'order_num', },
        { label: '客户名称', value: 'shname', },
      ],
      modalList: [],
      checkedIds: [],
      checkedLists: [],
      checkedTempLists: [],
      modalListProps: [
        { keyName: "predict_loading_date", label: "装货日期", },
        { label: '车牌号', keyName: 'license' },
        { label: '客户名称', keyName: 'shname' },
        // { label: '装车公司', keyName: 'company' },
        { label: '装货地址', keyName: 'coaddress' },
        { label: '卸货地址', keyName: 'enaddress' },
        { label: '装货量', keyName: 'inton' },
        { label: '卸货量', keyName: 'unton' },
        { label: '公司运费', keyName: 'freight' },
      ],
    };
  },
  methods: {
    formOrtherValidate() {
      // console.log(this.checkedIds)
      // console.log(this.checkedIds.length)
      let boo = true
      if (!this.checkedIds.length) {
        this.$message({
          type: 'error',
          message: '请选择运单！'
        });
        boo = false
      } else if (!this.form.money || !this.form.money.length || this.checkedIds.length !== this.form.money.length) {
        this.$message({
          type: 'error',
          message: '请填写补差金额！'
        });
        boo = false
      }
      return boo
    },
    onSearchFormChange({ key, value }) {
      // console.log(key, value)
      this.modalSearchForm[key] = value;
      // console.log({ ...this.modalSearchForm })
    },
    onModalSearch() {
      this.modalList = []
      let url = `${this.baseUrl}/getorder`;
      const params = {
        userid: this.user.id,
      }
      const object = this.modalSearchForm
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key) && object[key]) {
          params[key] = object[key];
        }
      }
      // console.log(url, params)
      this.post(url, params, this.modalResHandler, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    modalResHandler({ order }) {
      if (order && order.length) {
        this.modalList = order
      }
    },
    onModalSearchReset() {
      this.modalSearchForm = {}
      this.modalList = []
      const comFormCtrl = this.$refs['comFormCtrl']
      comFormCtrl && comFormCtrl.reset()
    },
    onCheckChange(v) {
      // console.log(v)
      // console.log(this.checkedIds)
      this.checkedTempLists = []
      this.modalList.map(c => {
        if (v.includes(c.id)) {
          this.checkedTempLists.push(c)
        }
      })
      // console.log(this.checkedTempLists)
    },
    onModalSubmit() {
      console.log(this.checkedIds)
      this.checkedLists = [...this.checkedTempLists]
      this.form.order_num = this.checkedIds
      this.hideDialog()
    },
    onModalCancel() {
      this.form.order_num = null
      this.hideDialog()
    },
    onClose() {
      this.modalSearchForm = {
        license: undefined,
        order_num: undefined,
        shname: undefined,
      }
      this.checkedTempLists = []
      const comFormCtrl = this.$refs['comFormCtrl']
      comFormCtrl && comFormCtrl.reset()
      this.onModalSearchReset()
      this.$forceUpdate()
    },
    showDialog() {
      this.checkedIds.length = 0
      this.$refs.dialog && this.$refs.dialog.show()
    },
    hideDialog() {
      this.$refs.dialog && this.$refs.dialog.hide()
    },
    onMoneyChange() {
      this.form.money = []
      this.checkedLists.map(v => {
        if (v.money || v.money === '0') {
          this.form.money.push(v.money)
        }
      })
      // console.log({ ...this.form })
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    border-bottom: 1px solid #f2f6fc;
    padding: 0 20px 15px 0;

    .el-textarea__inner {
      width: 300px;
      height: 85px;
      font-family:"Microsoft Yahei";
    }
  }
}

.btns {
  margin: 40px 0 60px 180px;
}

.orderlist {
  display: flex;
  flex-wrap: wrap;

  .item {
    width: 352px;
    background: #F9FBFC;
    margin: 0 15px 15px 0;
    position: relative;
    // box-shadow: 0px 0px 8px rgb(0 0 0 / 10%);
    color: #000;
    font-size: 14px;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #EAF0FC;
    box-sizing: border-box;

    &:nth-child(3n) {
      margin-right: 0;
    }

    &.is-checked {
      // box-shadow: 0px 0px 8px #409EFF;
      border: 1px solid #2691FF;
      position: relative;

      /deep/.el-checkbox__label {
        color: #000;
      }

      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        width: 36px;
        height: 24px;
        background: url(../../../assets/img/icon_order_checked.png);
      }
    }

    /deep/ .el-checkbox__input {
      display: none;
    }

    /deep/ .el-checkbox__label {
      padding: 0;
      width: 100%;
    }

    .row0 {
      height: 21px;
      font-size: 16px;
      color: #303133;
      margin-bottom: 15px;
    }

    .row1 {
      width: 100%;
      display: flex;
      line-height: 19px;

      &:not(:last-of-type) {
        margin-bottom: 10px;
      }

      .col0 {
        width: 70px;
        text-align: right;
        font-size: 14px;
        line-height: 19px;
        color: #909399;
      }

      .col1 {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .rowlast {
      display: flex;
      border-bottom: 1px solid #eee;
      padding: 0 15px;
      width: 322px;
      height: 43px;
      background: #F7F7F7;
      border-radius: 2px;
      border-bottom: 2px solid #2691FF;
      box-sizing: border-box;
      margin-top: 25px;

      input {
        flex: 1;
        background-color: transparent;
      }
    }
  }
}

.dialog {
  /deep/ .el-dialog {
    width: 1004px;
  }

  .searchForm {
    display: flex;
    flex-wrap: wrap;
    box-shadow: none;
    padding: 0;

    /deep/ .el-form-item {
      border: none;
      margin-right: 0;
    }
  }

  .modalForm {
    position: absolute;
    right: 20px;
    top: 84px;

    /deep/ .el-form-item {
      .el-form-item__content {
        .el-input {
          input {
            width: 170px;
            padding-right: 40px;
            background: #F2F6FC;
          }
        }

        .unit {
          position: absolute;
          right: 10px;
        }
      }
    }
  }

  .modal-scroll {
    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    /deep/ .is-horizontal {
      display: none;
    }
  }

  .orderlist {

    .item {
      width: 310px;
    }
  }

  .btns {
    text-align: center;
    margin-left: 0;
  }
}
</style>
